export default class Map {
  constructor() {
    this.setVars()
  }
  
  setVars() {
    this.settings = {
      init: 'data-map',
      default: 'data-map-default',
      map_voivodeship: 'data-map-voivodeship',
      select_voivodeship: 'data-select-voivodeship',
      option_voivodeship: 'data-option-voivodeship',
      employment: 'data-map-employment'
    };
    
    this.maps = document.querySelectorAll(`[${this.settings.init}]`);
    if (!this.maps) return false;
    
    this.setEvents();
  }
  
  setEvents() {
    this.maps.forEach(map => {
      const defaultValue = map.getAttribute(this.settings.default);
      
      this.setMap(map, defaultValue);
      this.setSelect(map, defaultValue);
      this.setEmployment(map, defaultValue);
      
      map.querySelectorAll(`[${this.settings.map_voivodeship}]`)
        .forEach(voivodeship => {
          voivodeship.addEventListener('click', (e) => {
            const voivodeship = e.target;
            const voivodeshipAttr = voivodeship.getAttribute(this.settings.map_voivodeship);
            
            this.setMap(map, voivodeshipAttr);
            this.setSelect(map, voivodeshipAttr);
            this.setEmployment(map, voivodeshipAttr);
          });
        });
      
      map.querySelector(`[${this.settings.select_voivodeship}]`)
         .addEventListener('change', (e) => {
        const voivodeship = e.target.value;
        this.setMap(map, voivodeship);
        this.setEmployment(map, voivodeship);
      })
    })
  }
  
  setMap(map, voivodeshipAttr) {
    map.querySelectorAll(`[${this.settings.map_voivodeship}]`)
       .removeClass('active');
    
    map.querySelector(`[${this.settings.map_voivodeship}="${voivodeshipAttr}"]`)
       .addClass('active')
  }
  
  setSelect(map, voivodeshipAttr) {
    const options = map.querySelector(`[${this.settings.select_voivodeship}]`).options;
  
    for (let i = 0; i < options.length; ++i) {
      if (options[i].value === voivodeshipAttr) options[i].selected = true;
    }
  }
  
  setEmployment(map, voivodeshipAttr) {
    map.querySelectorAll(`[${this.settings.employment}]`)
       .removeClass('show');
    
    map.querySelectorAll(`[${this.settings.employment}]`)
       .forEach(employment => {
          const employmentAttr = employment.getAttribute(this.settings.employment);
         
          if (employmentAttr.split(',').includes(voivodeshipAttr)) {
            employment.addClass('show')
          }
       })
  }
}
